import { DirectionSwitchButton } from '@eti/debug';
import { routes } from '../../../constants/routesAndApisConstants';
import DebugAccessibilityReview from './DebugAccessibilityReview';
import DebugTexts from './DebugTexts';
import DebugSiteProperties from './DebugSiteProperties';
import DebugThemeSelect from './DebugThemeSelect';
import DebugOrderDetailPage from './DebugOrderDetailPage';
import DebugOrderStatusPage from './DebugOrderStatusPage';
import DebugSupportPage from './DebugSupportPage';
import DebugMyBookingsPage from './DebugMyBookingsPage';

const DebugCommonComponents = () => {
  const isOrderDetailsPage = window.location.pathname.includes(routes.ORDER_DETAILS);
  const isOrderStatusPage = window.location.pathname.includes(routes.ORDER_STATUS);
  const isSupportPage = window.location.pathname.includes(routes.SUPPORT);
  const isMyBookingsPage = window.location.pathname.includes(routes.ORDER_LIST);

  return (
    <>
      <DirectionSwitchButton />
      <DebugTexts />
      <DebugSiteProperties />
      {isOrderDetailsPage && <DebugOrderDetailPage />}
      {isOrderStatusPage && <DebugOrderStatusPage />}
      {isSupportPage && <DebugSupportPage />}
      {isMyBookingsPage && <DebugMyBookingsPage />}
      <DebugAccessibilityReview />
      <DebugThemeSelect />
    </>
  );
};

export default DebugCommonComponents;
